module.exports = __webpack_public_path__ + "static/img/img-watcher-right.e9905dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b122/img-watcher-right.png
// module id = rNYI
// module chunks = 0